import AlertTable from "../../Components/AlertTable.jsx";
import SimpleFooter from "../../Components/SimpleFooter.jsx";
import useAlertsList from "./useAlertsList.js";
import {
  BellAlertIcon,
} from '@heroicons/react/24/outline';

export default function AlertsList() {
  // Dummy weather alert data for testing
  const dummyWeatherAlerts = [
    {
      "id": "688276a5c27d070dad919033",
      "loc": {
        "long": 8.9878771892086,
        "lat": 41.863689973825
      },
      "dataSource": "meteoalarm",
      "details": {
        "type": "AW.TS.MD",
        "name": "MODERATE THUNDERSTORM",
        "loc": "FR831",
        "emergency": false,
        "priority": 71.1,
        "color": "FF7000",
        "cat": "thunderstorm",
        "body": "Moderate damages may occur, especially in vulnerable or in exposed areas and to people who carry out weather-related activities.",
        "bodyFull": "Moderate damages may occur, especially in vulnerable or in exposed areas and to people who carry out weather-related activities."
      },
      "timestamps": {
        "issued": 1753380077,
        "issuedISO": "2025-07-24T20:01:17+02:00",
        "begins": 1753394400,
        "beginsISO": "2025-07-25T00:00:00+02:00",
        "expires": 1753480800,
        "expiresISO": "2025-07-26T00:00:00+02:00",
        "updated": 1753380077,
        "updateISO": "2025-07-24T20:01:17+02:00",
        "added": 1753380517,
        "addedISO": "2025-07-24T20:08:37+02:00",
        "created": 1753380517,
        "createdISO": "2025-07-24T20:08:37+02:00"
      },
      "poly": "",
      "geoPoly": null,
      "includes": {
        "fips": [],
        "counties": [],
        "wxzones": [
          "FR214", "FR261", "FR263", "FR411", "FR412", "FR413", "FR414",
          "FR421", "FR422", "FR431", "FR432", "FR433", "FR434", "FR622",
          "FR625", "FR627", "FR631", "FR711", "FR714", "FR715", "FR716",
          "FR717", "FR718", "FR721", "FR722", "FR723", "FR724", "FR814",
          "FR821", "FR822", "FR823", "FR825", "FR831", "FR832"
        ],
        "zipcodes": []
      },
      "place": {
        "name": "alpes-de-haute-provence",
        "state": "",
        "country": "fr"
      },
      "profile": {
        "tz": "Europe/Paris",
        "isSmallPoly": false
      },
      "active": true,
      "localLanguages": [
        {
          "language": "fr",
          "name": "Vigilance jaune orages",
          "body": "Des phénomènes habituels dans la région mais occasionnellement et localement dangereux sont prévus (exemple : mistral, orage d'été, montée des eaux, fortes vagues submergeant le littoral)."
        },
        {
          "language": "en",
          "name": "Moderate thunderstorm warning",
          "body": "Moderate damages may occur, especially in vulnerable or in exposed areas and to people who carry out weather-related activities."
        }
      ]
    },
    {
      "id": "688276a5c27d070dad919034",
      "loc": {
        "long": 2.3522,
        "lat": 48.8566
      },
      "dataSource": "meteoalarm",
      "details": {
        "type": "AW.FL.MD",
        "name": "FLOOD WARNING",
        "loc": "FR750",
        "emergency": true,
        "priority": 85.5,
        "color": "FF0000",
        "cat": "flood",
        "body": "Severe flooding expected in low-lying areas. Immediate action required.",
        "bodyFull": "Severe flooding expected in low-lying areas. Immediate action required. Evacuate if necessary and follow local emergency services instructions."
      },
      "timestamps": {
        "issued": 1753380077,
        "issuedISO": "2025-07-24T20:01:17+02:00",
        "begins": 1753394400,
        "beginsISO": "2025-07-25T00:00:00+02:00",
        "expires": 1753480800,
        "expiresISO": "2025-07-26T00:00:00+02:00",
        "updated": 1753380077,
        "updateISO": "2025-07-24T20:01:17+02:00",
        "added": 1753380517,
        "addedISO": "2025-07-24T20:08:37+02:00",
        "created": 1753380517,
        "createdISO": "2025-07-24T20:08:37+02:00"
      },
      "place": {
        "name": "paris",
        "state": "",
        "country": "fr"
      },
      "active": true,
      "localLanguages": [
        {
          "language": "fr",
          "name": "Alerte inondation",
          "body": "Inondations sévères attendues dans les zones basses. Action immédiate requise."
        },
        {
          "language": "en",
          "name": "Flood Warning",
          "body": "Severe flooding expected in low-lying areas. Immediate action required."
        }
      ]
    }
  ];

  const {
    alertsList,
    alertsLoading,
    toggleAlertLoading,
    currentPage,
    lastPage,
    totalAlertsCount,
    perPageCount,
    searchTerm,
    onToggleAlert,
    onSearch,
    onPageChange,
    setSearchTerm,
  } = useAlertsList();

  return (
    <>
      <div className="min-h-screen p-2 sm:p-4 md:p-6">
        <div className="mb-4 sm:mb-6 px-2 sm:px-4">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 gap-4 sm:gap-0">
            <div className="flex items-center space-x-2">
              <BellAlertIcon className="h-6 w-6 sm:h-8 sm:w-8 text-blue-600" />
              <h1 className="text-xl sm:text-2xl font-bold text-white">Alerts Management</h1>
            </div>
          </div>
          
          {/* <div className="mb-4">
            <input
              type="text"
              placeholder="Search alerts..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && onSearch(searchTerm)}
              className="w-full max-w-md px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <button
              onClick={() => onSearch(searchTerm)}
              className="ml-2 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
            >
              Search
            </button>
          </div> */}
        </div>

        <AlertTable 
          alertsData={alertsList}
          loading={false}
          onToggle={onToggleAlert}
          currentPage={1}
          lastPage={1}
          totalCount={alertsList.length}
          onPageChange={onPageChange}
          showEdit={false}
          showDelete={false}
          showCreate={false}
        />
      </div>
      <SimpleFooter />
    </>
  );
}